<template>
	<v-btn
		v-if="!desabilitarAssinatura"
		id="botaoAssinar"
		data-test="button.assinar"
		depressed
		fixed
		class="botao-assinar"
		color="primary"
		@click="$emit('assinar')"
	>
		<v-icon>mdi-draw-pen</v-icon>
		<div class="ml-2 text-capitalize">Assinar</div>
	</v-btn>
</template>

<script>
export default {
	name: 'botao-assinar-documento',
	props: {
		desabilitarAssinatura: {
			type: Boolean,
		},
	},
}
</script>

<style scoped lang="stylus">
.botao-assinar
	bottom 5vh
	right 2vw
</style>
